// src/utils/orderDiscountInfo.js

export const buildOrderDiscountInfo = ({
  discount,
  subtotal,
  totalItems,
  lang = "EN",
}) => {
  if (!discount) {
    return {
      hasDiscount: false,
      valid: false,
      label: "",
      conditionLabel: "",
      endLabel: "",
      discountAmount: 0,
      finalTotal: Number(subtotal || 0),
    };
  }

  const subtotalValue = Number(subtotal || 0);
  const itemsCount = Number(totalItems || 0);

  const minRequirement = discount.min_requirement || "none";
  const minAmount = Number(discount.min_amount || 0);
  const minQty = Number(discount.min_qty || 0);

  const discountType = discount.discount_type;
  const discountValue = Number(discount.discount_value || 0);

  let valid = false;
  let label = "";
  let conditionLabel = "";

  const valueLabel =
    discountType === "percentage"
      ? `${discountValue}%`
      : `$${discountValue.toFixed(2)}`;

  if (minRequirement === "none") {
    valid = true;

    conditionLabel =
      lang === "AR"
        ? "على جميع الطلبات"
        : "on all orders";
  }

  if (minRequirement === "amount") {
    valid = subtotalValue >= minAmount;

    const missingAmount = Math.max(0, minAmount - subtotalValue);

    conditionLabel =
      lang === "AR"
        ? `للطلبات فوق $${minAmount.toFixed(2)}`
        : `on orders over $${minAmount.toFixed(2)}`;

    label = valid
      ? lang === "AR"
        ? `تم تفعيل خصم الطلب ${valueLabel}`
        : `Order discount unlocked: ${valueLabel} off`
      : lang === "AR"
      ? `أضف $${missingAmount.toFixed(2)} للحصول على خصم الطلب`
      : `Add $${missingAmount.toFixed(2)} more to unlock order discount`;
  }

  if (minRequirement === "qty") {
    valid = itemsCount >= minQty;

    const missingQty = Math.max(0, minQty - itemsCount);

    conditionLabel =
      lang === "AR"
        ? `عند شراء ${minQty}+ منتجات`
        : `when buying ${minQty}+ items`;

    label = valid
      ? lang === "AR"
        ? `تم تفعيل خصم الطلب ${valueLabel}`
        : `Order discount unlocked: ${valueLabel} off`
      : lang === "AR"
      ? `أضف ${missingQty} منتجات للحصول على خصم الطلب`
      : `Add ${missingQty} more item${missingQty === 1 ? "" : "s"} to unlock order discount`;
  }

  if (minRequirement === "none") {
    label =
      lang === "AR"
        ? `تم تفعيل خصم الطلب ${valueLabel}`
        : `Order discount unlocked: ${valueLabel} off`;
  }

  let discountAmount = 0;

  if (valid) {
    if (discountType === "percentage") {
      discountAmount = (subtotalValue * discountValue) / 100;
    }

    if (discountType === "fixed") {
      discountAmount = discountValue;
    }

    discountAmount = Math.min(discountAmount, subtotalValue);
  }

  const endLabel = discount.end_at
    ? new Date(discount.end_at).toLocaleString(lang === "AR" ? "ar" : "en", {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
      })
    : "";

  return {
    hasDiscount: true,
    valid,
    label,
    conditionLabel,
    endLabel,
    discountAmount,
    finalTotal: Math.max(0, subtotalValue - discountAmount),
  };
};